import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './components/app/App';
import AppShell from './components/app/AppShell';
import './index.scss';
import './i18n/config';
import { hydratePreloadCache } from './common/contentPreload';

// Seed contentPreload from the prerendered page's embedded data (if any)
// before the first render, so hydration doesn't show a loading skeleton
// then immediately replace it with content it already has.
hydratePreloadCache();

const app = (
  <HelmetProvider>
    <BrowserRouter>
      <AppShell>
        <App />
      </AppShell>
    </BrowserRouter>
  </HelmetProvider>
);

const container = document.getElementById('root');
// Prerendered pages (scripts/prerender.js) ship real markup in #root —
// hydrateRoot reconciles against it instead of blowing it away and
// re-rendering from scratch (createRoot). The marker is set by the
// prerender script; falls back to createRoot for any route it didn't cover.
if (container.hasChildNodes() && container.dataset.prerendered)
  hydrateRoot(container, app);
else
  createRoot(container).render(app);
